import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {BaseComponent} from "../../../../shared/base.component";
import {FieldMap, Option, Rule} from "../../../../_typing/query-builder";
import {SelectFilterComponent} from "../../../select-filter/select-filter.component";
import {MatSelectChange} from "@angular/material/select";
import {SelectSearchApiComponent} from "../../../select-search-api/single/select-search-api.component";
import {
    QueryFieldOption,
    QueryFieldSearchService
} from "../../services/query-field-search.service";

@Component({
    selector: 'wire-field-option',
    templateUrl: './wire-field-option.component.html',
    imports: [
        SelectFilterComponent,
        SelectSearchApiComponent
    ],
    styleUrls: ['./wire-field-option.component.scss']
})
export class WireFieldOptionComponent extends BaseComponent implements OnChanges {
    @Input() rule: Rule;
    @Input() value: string;
    @Input() readonly fields: FieldMap;
    @Output() selectedFieldChanged: EventEmitter<string> = new EventEmitter();

    fieldOptions: Option[];
    selectedOption: QueryFieldOption;

    constructor(public queryFieldSearch: QueryFieldSearchService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['fields'] && this.fields) {
            this.queryFieldSearch.setFields(this.fields);
            this.fieldOptions = Object.entries(this.fields).map(([key, f]) => {
                return {name: f.name, value: f.value || key};
            }).sort((a, b) => a.name.localeCompare(b.name));
        }
        if ((changes['fields'] || changes['value']) && this.fields) {
            this.selectedOption = this.queryFieldSearch.getSelectedOption(this.value);
        }
    }

    setSelectedField(event: string): any {
        this.selectedFieldChanged.next(event);
    }

    setSelectedSearchField(event: MatSelectChange): void {
        const option = event.value as QueryFieldOption;
        if (!option) {
            return;
        }
        this.queryFieldSearch.addField(option);
        this.selectedOption = option;
        this.selectedFieldChanged.next(option.id);
    }

    fetchData = (pageNumber: number, filterValue: string) =>
        this.queryFieldSearch.fetchData(pageNumber, filterValue);
}
